@let verticals = this.verticals();

<div class="vertical-links">
  <a href="#" class="link">
    <span>{{ 'GENERAL.BTN.CATS' | translate }}</span>
  </a>

  <div class="vertical-link-box">
    <div class="header">
      <div class="title">
        {{ 'COMPONENTS.VERTICAL_LINK_BOX.HEADER_TITLE' | translate }}
      </div>

      <p>{{ 'COMPONENTS.VERTICAL_LINK_BOX.HEADER_SUBTITLE' | translate }}</p>
    </div>

    <div class="verticals">
      @for (vertical of verticals; track $index) {
        <div>
          <a [href]="vertical.link">{{ vertical.label }}</a>
        </div>
      }

      <div>
        <a class="all" [href]="'categories' | seoRoute">{{
          'GENERAL.BTN.SEE_ALL' | translate
        }}</a>
      </div>
    </div>
  </div>
</div>
